/**
 *  @class
 *  @function Timeline
 */

if (!customElements.get('time-line')) {
	class Timeline extends HTMLElement {
		constructor() {
			super();
			this.id = this.dataset.id;
			this.scroller = this.querySelector('.timeline--scroll-container');
			this.progressBar = document.getElementById('time-line-progress-' + this.id);
			this.items = this.querySelectorAll('.timeline--slide');
			this.labels = this.querySelectorAll('.timeline--scroll-pagination li');
		}
		connectedCallback() {
			const _this = this;

			if (this.progressBar) {
				_this.scroller.addEventListener('scroll', () => this.onScroll(), { passive: true });
			}

			_this.labels.forEach((item) => {
				_this.setLabelPosition(item);
			});
		}
		setLabelPosition(item) {
			let contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
				arr = Array.prototype.slice.call(this.labels),
				i = arr.indexOf(item),
				itemWidth = this.items[i].offsetWidth;

			item.style.flex = (itemWidth / contentWidth);
		}
		onScroll() {
			let scrollLeft = this.scroller.scrollLeft,
				scrollerWidth = this.scroller.offsetWidth,
				contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
				scrollPercent = (scrollLeft) / (contentWidth - scrollerWidth);

			this.progressBar.style.transform = 'scaleX(' + scrollPercent + ')';
		}
	}
	customElements.define('time-line', Timeline);
}
